import { useState } from "react";
import { FranchiseDeleteModal } from "./delete";
import type { IFranchiseDeleteModal } from "@dealer-center/ddc-pages-franchise-management-interface";

export const useFranchiseModals = () => {
  const [modal, setModal] = useState<React.ReactElement>(<></>);

  const showDeleteModal = (values: IFranchiseDeleteModal) => {
    setModal(
      <FranchiseDeleteModal
        close={() => {
          setModal(<></>);
        }}
        show={true}
        values={values}
      />
    );
  };

  return {
    showDeleteModal,
    modal
  };
};
